import { Input, ViewChild } from '@angular/core';
import { BaseEntity } from "../base-models/base-entity";
import { List } from 'immutable';
import { BaseUpdateComponent } from './base-update-component';
import { QueryParameter } from '../base-models/query-parameter';
// import { PARAMETERS } from '@angular/core/src/util/decorators';

export class BaseDetailListSum<T extends BaseEntity> {
    constructor(){
    }

    @Input() Parameters;
    
    Items: List<T>;
    @Input('Items') set SetItems(items: List<T>){
        this.Items = items;
        this.calculate();
    }

    SumTaxBase(){
    }

    SumTax(){
    }

    SumTotal(){
    }

    calculate(){

    }
}